export default class Navigation{
    constructor(list) {
        this.eles = document.querySelectorAll('#header .list li');
        this.evt = document.createEvent('Event');
        this.evt.initEvent('navigation', false, false);

        let len = this.eles.length;
        while( len-- ){
            this.eles[len].querySelector('button').setAttribute('data-key', list[len]);
            this.eles[len].querySelector('button').addEventListener('click', this._change.bind(this) );
        }
    }

    set(key){
        let len = this.eles.length;
        while( len-- ) this.eles[len].setAttribute('class', '');
        document.querySelector('[data-key='+key+']').parentNode.setAttribute('class', 'on');
    }

    _change(e){
        this.set( e.currentTarget.getAttribute('data-key') );
        e.currentTarget.dispatchEvent( this.evt );
    }
}




// WEBPACK FOOTER //
// ./src/js/mainDeath/navigation.js